export default "__VITE_ASSET__B2TXndc3__"